export * from './home-page.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/home-page/index.ts